<template>
  <div v-if="modules.length" class="mobile-module-nav">
    <div ref="moduleRow" class="mobile-module-row">
      <button
        v-for="mod in modules"
        :key="mod.key"
        type="button"
        class="mobile-module-chip"
        :class="{ 'is-active': mod.key === activeModuleKey }"
        @click="openModule(mod)">
        {{ mod.title }}
      </button>
    </div>
    <div v-if="activePages.length" ref="pageRow" class="mobile-module-row mobile-module-row--pages">
      <button
        v-for="page in activePages"
        :key="page.path"
        type="button"
        class="mobile-page-chip"
        :class="{ 'is-active': page.path === activePagePath }"
        @click="openPage(page)">
        {{ page.title }}
      </button>
    </div>
  </div>
</template>

<script>
import sidebarMenuRoutes from './Sidebar/sidebarMenuRoutes'
import { buildMobileModules, pathUnder } from './mobileMenu'

export default {
  name: 'MobileModuleNav',
  mixins: [sidebarMenuRoutes],
  computed: {
    modules() {
      return buildMobileModules(this.routes)
    },
    activeModule() {
      const current = this.$route.path
      const matched = this.modules.filter((mod) => {
        if (pathUnder(mod.matchPrefix, current)) return true
        return (mod.pages || []).some((page) => pathUnder(page.path, current))
      })
      if (!matched.length) return null
      matched.sort((a, b) => String(b.matchPrefix || '').length - String(a.matchPrefix || '').length)
      return matched[0]
    },
    activeModuleKey() {
      return this.activeModule ? this.activeModule.key : ''
    },
    activePages() {
      return this.activeModule ? this.activeModule.pages : []
    },
    activePagePath() {
      const current = this.$route.path
      const hits = this.activePages.filter((page) => pathUnder(page.path, current))
      if (!hits.length) return ''
      hits.sort((a, b) => b.path.length - a.path.length)
      return hits[0].path
    }
  },
  watch: {
    '$route.path'() {
      this.scrollActiveIntoView()
    },
    activeModuleKey() {
      this.scrollActiveIntoView()
    }
  },
  mounted() {
    this.scrollActiveIntoView()
  },
  methods: {
    openModule(mod) {
      if (!mod) return
      if (mod.external) {
        window.open(mod.path, '_blank')
        return
      }
      if (mod.key === this.activeModuleKey) return
      if (!mod.path || mod.path === this.$route.path) return
      this.$router.push(mod.path).catch(() => {})
    },
    openPage(page) {
      if (!page) return
      if (page.external) {
        window.open(page.path, '_blank')
        return
      }
      if (!page.path || page.path === this.$route.path) return
      this.$router.push(page.path).catch(() => {})
    },
    scrollActiveIntoView() {
      this.$nextTick(() => {
        this.scrollChip(this.$refs.moduleRow)
        this.scrollChip(this.$refs.pageRow)
      })
    },
    scrollChip(row) {
      if (!row || !row.querySelector) return
      const chip = row.querySelector('.is-active')
      if (!chip) return
      const left = chip.offsetLeft
      const right = left + chip.offsetWidth
      if (left < row.scrollLeft) {
        row.scrollLeft = Math.max(0, left - 8)
      } else if (right > row.scrollLeft + row.clientWidth) {
        row.scrollLeft = right - row.clientWidth + 8
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.mobile-module-nav {
  position: sticky;
  top: 50px;
  z-index: 1001;
  background: #fff;
  border-bottom: 1px solid #e4e7ed;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.06);
}

.mobile-module-row {
  position: relative;
  display: flex;
  flex-wrap: nowrap;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior-x: contain;
  gap: 4px;
  padding: 6px 8px 4px;
  &::-webkit-scrollbar {
    height: 0;
  }
}

.mobile-module-row--pages {
  background: #f5f7fa;
  padding-top: 4px;
  padding-bottom: 8px;
}

.mobile-module-chip,
.mobile-page-chip {
  flex: 0 0 auto;
  border: 0;
  margin: 0;
  cursor: pointer;
  line-height: 1.2;
  white-space: nowrap;
}

.mobile-module-chip {
  min-height: 36px;
  padding: 8px 12px;
  background: transparent;
  color: #606266;
  font-size: 15px;
  border-radius: 4px;
  &.is-active {
    color: #409eff;
    font-weight: 600;
    box-shadow: inset 0 -2px 0 #409eff;
  }
}

.mobile-page-chip {
  min-height: 32px;
  padding: 6px 12px;
  background: #fff;
  color: #606266;
  font-size: 13px;
  border-radius: 16px;
  border: 1px solid #dcdfe6;
  &.is-active {
    background: #409eff;
    border-color: #409eff;
    color: #fff;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/MobileModuleNav.vue